import React, { FC, } from 'react';
import '../style/temp.less';

export interface Props {
    dataField?: any
    index: number
}
interface SetProps {
    dataField?: any
    id?: string
    methods?: any
    selectedInfo?: any
    otherInfo?: any
}

const ActiveGroup: FC<Props> = ({ dataField }) => {
    return (
        <div className="preview-container" >
            ActiveGroup
        </div>
    )
}

export const ActiveGroupSet: FC<SetProps> = ({ dataField, id }) => {

    return <div className="setting-container">
        ActiveGroup
    </div>
}

export default ActiveGroup